/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { useRef, useState } from 'react';

export type NextStateType<S> = <K extends keyof S>(
  nextState: (Pick<S, K> | S) | ((prevState: Readonly<S>) => S),
) => void;

export const useObjectState = <S = undefined>(initialState: (() => S) | S): [S, NextStateType<S>] => {
  const [state, setState] = useState<S>(initialState);
  const nextSetState = useRef<NextStateType<S>>(nextState => {
    if (typeof nextState === 'function') {
      setState(nextState);
    } else if (typeof nextState === 'object') {
      setState(prevState => ({ ...prevState, ...nextState }));
    }
  });
  return [state, nextSetState.current];
};
